// 2022-03-29
// credits: https://w3bits.com/javascript-slidetoggle/

/*
const slideToggle = (target) =>
{
	const animation = new Animation(target,
	{
		height:
		{
			from: null,
			to: 0
		},
		'padding-top':
		{
			from: null,
			to: 0
		},
		'padding-bottom':
		{
			from: null,
			to: 0
		},
		'margin-top':
		{
			from: null,
			to: 0
		},
		'margin-bottom':
		{
			from: null,
			to: 0
		},
	}, Animation.easeOutCubic);
	
	animation.onStart = (reverse) =>
	{
		console.log('started')
		
		target.style.display = 'block';
		target.style.overflow = 'hidden';
		target.style.boxSizing = 'border-box';
		target.style.height = target.offsetHeight + 'px';
		
		target.style.removeProperty('padding-top');
		target.style.removeProperty('padding-bottom');
		target.style.removeProperty('margin-top');
		target.style.removeProperty('margin-bottom');
		
		animation.initialize();
		
		console.log(animation);
	};
	
	animation.onEnd = (reverse) =>
	{
		console.log('ended')
		
		if(!reverse) target.style.display = 'none';
		target.style.removeProperty('height');
		target.style.removeProperty('padding-top');
		target.style.removeProperty('padding-bottom');
		target.style.removeProperty('margin-top');
		target.style.removeProperty('margin-bottom');
		target.style.removeProperty('overflow');
	};
	
	return animation;
};
*/

let slideUp = (target, duration=500) =>
{
	target.style.transitionProperty = 'height, margin, padding';
	target.style.transitionDuration = duration + 'ms';
	target.style.boxSizing = 'border-box';
	target.style.height = target.offsetHeight + 'px';
	
	const promise = new Promise((resolve, reject) =>
	{
		window.setTimeout(() =>
		{
			target.style.overflow = 'hidden';
			target.style.height = 0;
			target.style.paddingTop = 0;
			target.style.paddingBottom = 0;
			target.style.marginTop = 0;
			target.style.marginBottom = 0;
		}, 0);
		
		window.setTimeout(() =>
		{
			target.style.display = 'none';
			target.style.removeProperty('height');
			target.style.removeProperty('padding-top');
			target.style.removeProperty('padding-bottom');
			target.style.removeProperty('margin-top');
			target.style.removeProperty('margin-bottom');
			target.style.removeProperty('overflow');
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
			
			resolve();
		}, duration);
	});
	
	return promise;
};

let slideDown = (target, duration=500) =>
{
	target.style.removeProperty('display');
	let display = window.getComputedStyle(target).display;
	
	if(display === 'none') display = 'block';
	
	target.style.display = display;
	let height = target.offsetHeight;
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	
	const promise = new Promise((resolve, reject) =>
	{
		window.setTimeout(() =>
		{
			target.style.boxSizing = 'border-box';
			target.style.transitionProperty = "height, margin, padding";
			target.style.transitionDuration = duration + 'ms';
			target.style.height = height + 'px';
			
			target.style.removeProperty('padding-top');
			target.style.removeProperty('padding-bottom');
			target.style.removeProperty('margin-top');
			target.style.removeProperty('margin-bottom');
		}, 0);
		
		window.setTimeout(() =>
		{
			target.style.removeProperty('height');
			target.style.removeProperty('overflow');
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
			
			resolve();
		}, duration);
	});
	
	return promise;
};

const slideToggle = (target, duration = 500, direction) =>
{
	if(window.getComputedStyle(target).display === 'none' || direction == 'down') return slideDown(target, duration);
	
	return slideUp(target, duration);
}

export default slideToggle;